import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CollapseDirectiveSharedModule } from '@shared/core/directives/collapse/collapse.directive.shared.module';

import { LoadersModule } from '@shared/core/components/loaders';
import { SquareImageModule } from '@shared/core/components/squareImage';
import { HeadersModule } from '@shared/core/components/headers';
import { StatsModule } from '@shared/core/components/stats';
import { TagImagesModule } from '@shared/core/components/tagImages';

import { VcardForWizzardComponent } from './vcard-for-wizzard.shared.component';

@NgModule({
    declarations: [
        VcardForWizzardComponent
    ],
    imports: [
        CommonModule,
        CollapseDirectiveSharedModule,
        LoadersModule,
        SquareImageModule,
        HeadersModule,
        StatsModule,
        TagImagesModule,
    ],
    exports: [
        VcardForWizzardComponent
    ],
    providers: [],
})
export class VcardForWizzardModule { }
